var _g, _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStratairuLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_STRATAIRU",
    "data-name": "Logo STRATAIRU",
    xmlns: "http://www.w3.org/2000/svg",
    width: 163,
    height: 81.867,
    viewBox: "0 0 163 81.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(-206.705 -96.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M15.937,52.137a15.017,15.017,0,0,0-5.433.981,13.981,13.981,0,0,0-7.669,18.53C4.142,74.6,7.181,78.634,14.216,81.14a30.831,30.831,0,0,0,15.238,1.223c5.162-.948,8.729-3.218,10.045-6.389,3.115-7.537-6.347-17.783-14.228-21.527a21.876,21.876,0,0,0-9.334-2.313m8.39,32.339A32.379,32.379,0,0,1,13.657,82.7c-4.193-1.491-9.735-4.5-12.344-10.38A15.645,15.645,0,0,1,9.9,51.565c3.319-1.279,8.8-2.078,16.082,1.38,8.667,4.117,18.588,15.114,15.048,23.667C39.5,80.322,35.488,82.945,29.753,84a29.935,29.935,0,0,1-5.428.477",
    transform: "translate(254 55.555)",
    fill: "#262051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M63.824,1.666A13.963,13.963,0,0,0,57.9,3h0a13.7,13.7,0,0,0-7.3,8.085c-1.027,3.055-1.518,8.081,1.977,14.686a30.824,30.824,0,0,0,10.41,11.2c4.445,2.786,8.611,3.526,11.722,2.078,7.387-3.454,7.335-17.4,4.051-25.485C76.533,8.084,73.08,4.3,68.769,2.606a13.455,13.455,0,0,0-4.947-.94m7.44,39.769A17.641,17.641,0,0,1,62.1,38.38,32.575,32.575,0,0,1,51.1,26.554c-2.082-3.931-4.135-9.9-2.084-15.994a15.651,15.651,0,0,1,20.359-9.5c3.309,1.3,7.89,4.414,10.92,11.881,3.613,8.892,3.5,23.7-4.891,27.617a9.745,9.745,0,0,1-4.144.878",
    transform: "translate(215.166 96.243)",
    fill: "#262051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M168.415,52.139a21.87,21.87,0,0,0-9.334,2.313c-7.882,3.743-17.343,13.99-14.228,21.53,1.316,3.167,4.885,5.437,10.045,6.385a30.832,30.832,0,0,0,15.238-1.223c7.035-2.506,10.074-6.544,11.381-9.493a13.981,13.981,0,0,0-7.669-18.53,14.977,14.977,0,0,0-5.433-.981m-8.39,32.339A29.931,29.931,0,0,1,154.6,84c-5.734-1.055-9.741-3.679-11.28-7.384-3.54-8.556,6.381-19.553,15.048-23.67,4.02-1.907,10.07-3.695,16.081-1.38a15.652,15.652,0,0,1,8.591,20.759c-1.442,3.243-4.749,7.678-12.344,10.38a32.359,32.359,0,0,1-10.668,1.77",
    transform: "translate(139.057 55.553)",
    fill: "#262051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M151.249,1.668a13.509,13.509,0,0,0-4.947.94c-4.311,1.69-7.764,5.48-9.987,10.958-3.284,8.085-3.336,22.031,4.055,25.485,3.107,1.448,7.273.709,11.724-2.078a30.876,30.876,0,0,0,10.406-11.2c3.5-6.6,3-11.629,1.977-14.688a13.687,13.687,0,0,0-7.3-8.081,13.978,13.978,0,0,0-5.928-1.338m-7.44,39.769a9.752,9.752,0,0,1-4.145-.878c-8.386-3.92-8.5-18.725-4.89-27.617C136.45,8.822,139.7,3.416,145.7,1.063a15.281,15.281,0,0,1,12.181.436,15.334,15.334,0,0,1,8.173,9.06c1.13,3.367,1.686,8.87-2.084,15.994A32.576,32.576,0,0,1,152.977,38.38a17.641,17.641,0,0,1-9.163,3.055",
    transform: "translate(147.168 96.241)",
    fill: "#262051"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M472.876,31.582H420.187c-2.034,0-3.685-2.3-3.685-5.143V9.5c0-2.839,1.65-5.141,3.685-5.141h52.689c2.034,0,3.684,2.3,3.684,5.141v16.94c0,2.841-1.65,5.143-3.684,5.143",
    transform: "translate(-416.502 50.285)",
    fill: "#262051"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M1246.966,54.263l-2.645,7.295h5.269l-2.623-7.295Zm4.554,12.969-1-2.741h-7.1l-1,2.741h-3.718l6.149-15.9h4.245l6.126,15.9Z",
    transform: "translate(-1174.813 8.932)",
    fill: "#262051"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M1402.8,67.231V54.309h-4.648V51.33h12.683v2.979h-4.626V67.231Z",
    transform: "translate(-1315.199 8.932)",
    fill: "#262051"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M1533.586,54.263l-2.644,7.295h5.269l-2.623-7.295Zm4.554,12.969-1-2.741h-7.1l-1,2.741h-3.717l6.149-15.9h4.245l6.126,15.9Z",
    transform: "translate(-1427.151 8.932)",
    fill: "#262051"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498",
    "data-name": "Rectangle 498",
    width: 3.385,
    height: 15.902,
    transform: "translate(119.738 60.262)",
    fill: "#262051"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M1797.492,54.239h-3.553v4.386h3.553a2.2,2.2,0,1,0,0-4.385m2.05,12.992-3.123-5.7h-2.481v5.7h-3.385V51.33h7.44a4.952,4.952,0,0,1,5.339,5.125,4.452,4.452,0,0,1-3.482,4.721l3.577,6.056Z",
    transform: "translate(-1660.666 8.932)",
    fill: "#262051"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M1948.605,51.33h3.431v9.441a3.4,3.4,0,0,0,3.7,3.744c2.479,0,3.647-1.525,3.647-3.744V51.33h3.432v9.536c0,3.957-2.263,6.65-7.08,6.65s-7.128-2.717-7.128-6.627V51.33Z",
    transform: "translate(-1799.812 8.932)",
    fill: "#262051"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M449.376,62.352A6.786,6.786,0,0,0,454.3,64.44c1.81,0,2.692-.859,2.692-1.74,0-1.16-1.346-1.555-3.133-1.972-2.529-.58-5.778-1.276-5.778-4.734,0-2.576,2.228-4.664,5.871-4.664a8.609,8.609,0,0,1,6.033,2.158L458.147,55.9a6.6,6.6,0,0,0-4.432-1.694c-1.485,0-2.274.65-2.274,1.578,0,1.044,1.3,1.369,3.086,1.787,2.552.58,5.8,1.346,5.8,4.78,0,2.831-2.019,4.966-6.2,4.966a8.918,8.918,0,0,1-6.567-2.46Z",
    transform: "translate(-443.85 8.932)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M600.307,68.747V56.171h-4.525v-2.9h12.344v2.9h-4.5V68.747Z",
    transform: "translate(-574.339 7.224)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M757.593,68.747l-3.04-5.546H752.14v5.546h-3.3V53.27h7.24a4.82,4.82,0,0,1,5.2,4.989,4.441,4.441,0,0,1-3.388,4.594l3.481,5.894Zm-2-12.646H752.14v4.27H755.6a2.142,2.142,0,1,0,0-4.27",
    transform: "translate(-709.094 7.224)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStratairuLogo);
export default __webpack_public_path__ + "static/media/stratairu-logo.9c44a90da28103e7c71465aa7c924b6f.svg";
export { ForwardRef as ReactComponent };